
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');

import VueEvent from './src/common/VueEvent';

import ToggleButton from "vue-js-toggle-button";
Vue.use(ToggleButton);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

import InputTag from "vue-input-tag";
Vue.component("input-tag", InputTag);

import PortalVue from 'portal-vue'
Vue.use(PortalVue)

window.vueEvent = new VueEvent;


import { ValidationProvider } from 'vee-validate/dist/vee-validate.full.esm';
Vue.component('ValidationProvider', ValidationProvider);

import route from 'ziggy';
import { Ziggy } from './ziggy';

Vue.mixin({
    methods: {
        route: (name, params, absolute) => route(name, params, absolute, Ziggy),
    }
});


window.mixin = {
    
    methods: {
        smallThumbnail(picture) {
          // `this` points to the vm instance
          if (picture) {
            return `/image/picture-dictionary/150x150${picture.picture_path}`;
          }

          return '';
        },

        saveLocalStorage() {
            this.$localStorage.set('picture-dictionary', JSON.stringify(this.store.selectedPictures))
        },

        getLocalStorage() {
            return this.$localStorage.get('picture-dictionary', [])
        },

        getImageRequestLocalStorage() {
            return this.$localStorage.get('image-request', [])
        },

        saveImageRequestLocalStorage() {
            this.$localStorage.set('image-request', JSON.stringify(this.store.imageRequests));
        },
    }, 
};

export const store = {
    selectedPictures: [],
    searchResultsPictures: [],
    imageRequests: [],
 }

Vue.component("modal", () =>
    import(/* webpackChunkName: "modal" */
    "./components/common/Modal.vue")
);

Vue.component("edit-picture", () =>
  import(/* webpackChunkName: "edit-picture" */
    "./components/pictures/EditPicture.vue")
);

Vue.component("add-picture", () =>
    import(/* webpackChunkName: "add-picture" */
    "./components/pictures/AddPicture.vue")
);

Vue.component("image-search", () =>
    import(/* webpackChunkName: "image-search" */
        "./components/image-handler/ImageSearch.vue")
);

Vue.component("image-repository", () =>
    import(/* webpackChunkName: "image-repository" */
    "./components/image-handler/ImageRepository.vue")
);

Vue.component("add-picture-modal", () =>
  import(/* webpackChunkName: "add-picture-modal" */
  "./components/image-handler/AddPictureModal.vue")
);

Vue.component("add-translation-modal", () =>
    import(/* webpackChunkName: "add-translation-modal" */
        "./components/image-handler/AddTranslationModal.vue")
);

Vue.component("edit-keyword-modal", () =>
    import(/* webpackChunkName: "edit-keyword-modal" */
        "./components/image-handler/EditKeywordModal.vue")
);

Vue.component("picture-dictionary", () =>
  import(/* webpackChunkName: "picture-dictionary" */
  "./components/image-handler/PictureDictionary.vue")
);

Vue.component("save-theme-modal", () =>
    import(/* webpackChunkName: "save-theme-modal" */
    "./components/image-handler/SaveThemeUnitModal.vue")
);

Vue.component("image-repository-management", () =>
  import(/* webpackChunkName: "image-repository-management" */
  "./components/image-handler/ImageRepositoryManagement.vue")
);

Vue.component("demo-dictionary", () =>
  import(/* webpackChunkName: "demo-dictionary" */
  "./components/demo/DemoDictionary.vue")
);

Vue.component("demo-unit-list", () =>
  import(/* webpackChunkName: "demo-unit-list" */
  "./components/demo/DemoUnitList.vue")
);

Vue.component("user-image-requet-table", () =>
  import(/* webpackChunkName: "user-image-requet-table" */
  "./components/table/UserImageRequestTable.vue")
);

Vue.component("admin-theme-unit-list", () =>
    import(/* webpackChunkName: "admin-theme-unit-list" */
    "./components/image-container/AdminThemeUnitList.vue")
);

Vue.component("request-image", () =>
  import(/* webpackChunkName: "request-image" */
  "./components/image-handler/RequestImage.vue")
);

Vue.component("image-request-table", () =>
    import(/* webpackChunkName: "image-request-table" */
    "./components/table/ImageRequestTable.vue")
);

Vue.component("demo-user-table", () =>
  import(/* webpackChunkName: "demo-user-table" */
  "./components/demo/DemoUserTable.vue")
);

Vue.component("manage-languages", () =>
  import(/* webpackChunkName: "manage-languages" */
  "./table/ManageLanguages.vue")
);

Vue.component("add-language-button", () =>
  import(/* webpackChunkName: "add-language-button" */
  "./components/partials/AddLanguageButton.vue")
);

Vue.component("loader", require("./components/partials/Loader.vue").default);

Vue.component("state-selector", () =>
  import(/* webpackChunkName: "state-selector" */
  "./components/partials/StateSelector.vue")
);

Vue.component("city-selector", () =>
  import(/* webpackChunkName: "city-selector" */
  "./components/partials/CitySelector.vue")
);

Vue.component("grade-level-selector", () =>
  import(/* webpackChunkName: "grade-level-selector" */
  "./components/partials/GradeLevelSelector.vue")
);

Vue.component("ela-video", () =>
  import(/* webpackChunkName: "ela-video" */
  "./components/partials/Video.vue")
);

Vue.component("campaign-form", () =>
  import(/* webpackChunkName: "campaign-form" */
  "./components/pages/CampaignForm.vue")
);

Vue.component("paginator", require("./components/partials/Paginator.vue").default);

Vue.component("items-per-page-selector", require("./components/partials/ItemsPerPageSelector.vue").default);

Vue.component("campaigns-table", () =>
  import(/* webpackChunkName: "campaigns-table" */
  "./components/vue-table/CampaignsTable.vue")
);

Vue.component("pointer-arrow-right", () =>
    import(/* webpackChunkName: "pointer-arrow-right" */
    "./components/demo/PointerArrowRight.vue")
);

Vue.component("pop-video", () =>
  import(/* webpackChunkName: "pop-video" */
  "./components/partials/PopElaVideo.vue")
);

Vue.component("button-video", () =>
    import(/* webpackChunkName: "button-video" */
        "./components/partials/ButtonVideo.vue")
);

Vue.component("user-downloads-modal", () =>
    import(/* webpackChunkName: "user-downloads-modal" */
    "./components/partials/UserDownloadsModal.vue")
);

Vue.component("button-event", () =>
    import(/* webpackChunkName: "button-event" */
    "./components/partials/ButtonEvent.vue")
);

Vue.component("success-notification", () =>
    import(/* webpackChunkName: "success-notification" */
        "./components/partials/SuccessNotification.vue")
);

Vue.component("ela-input-tag", () =>
    import(/* webpackChunkName: "ela-input-tag" */
        "./components/forms/InputTag.vue")
);

const app = new Vue({
    el: '#app',
});